import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService, Core2Config } from "../../shared";

@Injectable({
    providedIn: 'root'
})
export class CashTransferUploadService extends BaseApiTemplateService<any> {

    //https://api.akaun.com/core2/tnt/dm/erp/cash-document/import-file-hdrs/backoffice-ep

    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'cash-document/import-file-hdrs/backoffice-ep' + '?delimiter=COMMA';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'cash-document/import-file-hdrs/backoffice-ep' + '?delimiter=COMMA';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'cash-document/import-file-hdrs/backoffice-ep' + '?delimiter=COMMA';
        this.httpClient = http;
    }

}